// src/js/config/ui/showMessage.js

import { DOMElements } from '../dom.js';
import { getTransitionDurationMs } from '../../utils/helpers.js';

let messageTimerId = null;
let currentTransitionEndHandler = null;

/**
 * Döljer omedelbart och återställer meddelandefältet.
 * Används för att rensa gamla meddelanden innan ett nytt visas.
 */
export function hideMessage() {
    const { notificationMessage } = DOMElements;
    if (notificationMessage) {
        // Rensa eventuell pågående timer för att förhindra konflikter
        if (messageTimerId) {
            clearTimeout(messageTimerId);
            messageTimerId = null;
        }
        // Rensa eventuell gammal event listener
        if (currentTransitionEndHandler) {
            notificationMessage.removeEventListener('transitionend', currentTransitionEndHandler);
            currentTransitionEndHandler = null;
        }
        
        notificationMessage.textContent = '';
        notificationMessage.className = 'message'; // Återställer klasserna
    }
}

/**
 * Visar ett meddelande med en fade-in/fade-out-effekt.
 * @param {string} messageText - Texten som ska visas.
 * @param {string} type - Typ av meddelande ('success', 'error', 'warning', 'info').
 */
export function showMessage(messageText, type) {
    const messageElement = DOMElements.notificationMessage;
    
    if (!messageElement) {
        console.warn("Kunde inte visa meddelande: 'notificationMessage' DOM-element saknas. Meddelande: " + messageText);
        return;
    }

    // Använd hideMessage för att säkerställa en ren start
    hideMessage();
    
    messageElement.textContent = messageText;
    messageElement.classList.add(type);

    // Tvinga en DOM "reflow" för att säkerställa att CSS-transitionen startar korrekt
    void messageElement.offsetWidth; 

    messageElement.classList.add('is-visible');

    let displayDuration;
    if (type === 'error' || type === 'warning') {
        // Längre tid för viktiga meddelanden
        displayDuration = 6000; // 6 sekunder
    } else {
        // Standardtid för info och success
        displayDuration = 3000; // 3 sekunder
    }
    
    messageTimerId = setTimeout(() => {
        messageElement.classList.remove('is-visible');

        currentTransitionEndHandler = (event) => {
            if (event.propertyName === 'opacity') {
                // Rensa efter att fade-out är klar
                hideMessage();
            }
        };
        
        messageElement.addEventListener('transitionend', currentTransitionEndHandler, { once: true });
    }, displayDuration);
}